export default __webpack_public_path__ + "static/media/grafema_the-creativity-virus_13.464c677d.jpg";